export default {
  filterSeperator: '__'
}
